export default {
  filterSeperator: '__'
}
